import { useParams } from 'react-router-dom'
import EmailTemplateForm from './EmailTemplateForm'

const View = () => {
    const params = useParams()

    return (
        <EmailTemplateForm
            id={parseInt(params.emailTemplateId!)}
            config={{
                submitSuccessMsg: {
                    header: 'Updated',
                    message: 'Email template updated successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to update email template',
                },
                saveButton: {
                    label: 'Update',
                    savingLabel: 'Updating template...',
                },
            }}
        />
    )
}

export default View
